import ApiController from '../controllers/ApiController';

/**
 * Monta a url da imagem para carregamento
 * @param {String} imagem Url da imagem a ser exibida
 * @returns {String} Url formatada, pronta para ser exibida
 */
function formatarUrlImagem(imagem) {
    const apiController = new ApiController();

    //Adiciona o prefixo e o caminho para o endpoint de imagens
    return apiController.adicionarPrefixo('/image/' + imagem);
}

export default formatarUrlImagem;